export enum CountryAlpha2 {
  AE = 'AE',
  AM = 'AM',
  AZ = 'AZ',
  BY = 'BY',
  CA = 'CA',
  CZ = 'CZ',
  DE = 'DE',
  EE = 'EE',
  ES = 'ES',
  FI = 'FI',
  GE = 'GE',
  GB = 'GB',
  GR = 'GR',
  HR = 'HR',
  ID = 'ID',
  IT = 'IT',
  KG = 'KG',
  LT = 'LT',
  LV = 'LV',
  RU = 'RU',
  RS = 'RS',
  TR = 'TR',
  UA = 'UA',
  US = 'US',
  KZ = 'KZ',
  AT = 'AT',
  BG = 'BG',
  MD = 'MD',
  CY = 'CY',
  ME = 'ME',
  IL = 'IL',
  BE = 'BE',
  RO = 'RO',
  PL = 'PL',
  CN = 'CN',
  UNKNOWN = '---',
}

export enum CountryAlpha3 {
  ARE = 'ARE',
  ARM = 'ARM',
  AZE = 'AZE',
  BLR = 'BLR',
  CAN = 'CAN',
  CZE = 'CZE',
  DEU = 'DEU',
  EST = 'EST',
  ESP = 'ESP',
  FIN = 'FIN',
  GEO = 'GEO',
  GBR = 'GBR',
  GRC = 'GRC',
  HRV = 'HRV',
  IDN = 'IDN',
  ITA = 'ITA',
  KGZ = 'KGZ',
  LTU = 'LTU',
  LVA = 'LVA',
  RUS = 'RUS',
  SRB = 'SRB',
  TUR = 'TUR',
  UKR = 'UKR',
  USA = 'USA',
  KAZ = 'KAZ',
  AUT = 'AUT',
  ISR = 'ISR',
  BEL = 'BEL',
  ROU = 'ROU',
  POL = 'POL',
  CHN = 'CHN',
  UNKNOWN = '---',
}

export namespace NDictionaries {
  export type Country = {
    alpha2?: string | null;
    id: number;
    name: string | null;
    code: string | null;
  };

  export type RequestParams = {
    userId: number;
    database: string;
    activeBranchId: number;
  };

  export type ModelCountry = {
    Id: number;
    Name: string;
    Alpha2: CountryAlpha2;
    Alpha3: CountryAlpha3;
    TelCode: string;
    MinDigits: number;
    MaxDigits: number;
  };

  export type ModelLanguage = {
    Id: number;
    CodeIso6391: string | null;
    CodeIso6393: string | null;
    Name: string | null;
  };
}
